import axios from "axios";
import { API_BASE, CHECKOUT_BASE } from "../../config/env";

export const FETCH_REMOVEADDRESS_FULFILLED = "FETCH_REMOVEADDRESS_FULFILLED";
export const FETCH_REMOVEADDRESS_REJECTED = "FETCH_REMOVEADDRESS_REJECTED";
export const FETCH_REMOVEADDRESS_PENDING = "FETCH_REMOVEADDRESS_PENDING";
export const RESET_REMOVEADDRESS = "RESET_REMOVEADDRESS";

export function removeAddress(Id) {
  const token = localStorage.getItem("accessToken");
  return (dispatch) => {
    dispatch({
      type: "FETCH_REMOVEADDRESS",
      payload: axios({
        method: "get",
        url: `${CHECKOUT_BASE}/gate/users/address/remove,id=${Id}`,
        headers: {
          Authorization: "Bearer " + token,
          "Accept-Language": "tr-tr",
          "Content-Type": "application/json",
          "Cart-Type": "fast-checkout"
        },
      }).then((result) => result.data),
    });
  };
}

export function resetRemoveAddress() {
  return (dispatch) => {
    dispatch({
      type: "RESET_REMOVEADDRESS",
    });
  };
}
